import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Box, BoxProps, Flex } from '@mantine/core'

import { Navigator } from 'components/organisms/serviceConnections/heroBanner/navigator'
import { BlockItem } from 'components/organisms/serviceConnections/heroBanner/navigator/blockItem'
import { UnderLine } from 'components/organisms/serviceConnections/heroBanner/navigator/blockItem/underLine'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'

type Props = {
  navigating: any
  onNavClick: any
  selectedSection?: string
  logo?: {
    icon: string
    url: string
  }
  showDownApp?: boolean
} & BoxProps

export const AppIntroNav = ({
  navigating,
  onNavClick,
  selectedSection,
  logo,
  showDownApp,
  styles,
  className,
  classNames,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AppIntroHeroBanner',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  return (
    <Flex
      align={'center'}
      justify={'space-between'}
      className={cx(className)}
      {...rest}
    >
      {!isMobile && logo?.icon && (
        <div className={classes.logo}>
          <img
            loading="lazy"
            src={logo?.icon}
            alt="App"
            className={classes.logoImg}
          />
        </div>
      )}
      <Flex align={'center'} gap={36}>
        <Navigator
          navigating={navigating}
          iconSize={24}
          selectedSection={selectedSection}
          // dataActionBySession={(() => {
          //   const temp: { [key in SessionType]?: string } = {}
          //   Object.keys(DATA_TRACKING_ACTION_BY_SESSION).map((i) => {
          //     temp[i as SessionType] = `${
          //       DATA_TRACKING_ACTION_BY_SESSION[i as SessionType]
          //     } - Header Navigate`
          //   })
          //   return temp
          // })()}
          onNavClick={onNavClick}
        >
          {navigating.map((_i: any, idx: number) => (
            <BlockItem
              key={String(idx)}
              // classNames={{
              //   root: classes.navigatorItem,
              // }}
              displayAs={UnderLine}
              // iconSize={18}
              // isExternalUrl={linkDataByIdScroll[i.idScroll]?.isExternalSite}
              // target={
              //   linkDataByIdScroll[i.idScroll]?.isExternalUrl
              //     ? '_blank'
              //     : '_self'
              // }
            />
          ))}
        </Navigator>
        {showDownApp && (
          <Flex align={'center'} gap={16}>
            <Box
              component={isMobile && logo?.url ? 'a' : 'div'}
              {...(isMobile &&
                logo?.url && {
                  href: logo.url,
                  target: '_blank',
                })}
            >
              <div className={classes.app}>
                <img
                  src={CommonGAssets.getAssetPath('appIntro/app-store.png')}
                  className={classes.appImg}
                  loading={'lazy'}
                  alt="App Store"
                />
              </div>
            </Box>
            <Box
              component={isMobile && logo?.url ? 'a' : 'div'}
              {...(isMobile &&
                logo?.url && {
                  href: logo.url,
                  target: '_blank',
                })}
            >
              <div className={classes.app}>
                <img
                  src={CommonGAssets.getAssetPath('appIntro/google-play.png')}
                  className={classes.appImg}
                  loading={'lazy'}
                  alt="Google Play"
                />
              </div>
            </Box>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}
